import React from 'react';
import PropTypes from 'prop-types';
import { secondsToTimeAgo, getTimeSinceLastUpdated } from '../helpers';
import createRefreshControls from './createRefreshControls';
import styles from './RefreshControls.module.scss';

const RefreshView = (props) => (props.timeLastUpdated !== null ? (
    <div className={ props.styles['refresh-controls'] }>
        <button type="button" onClick={ props.onClick } className={ props.styles.button }>
            refresh
        </button>
        { props.timeLastUpdated && (
            <span>
                Updated
                &nbsp;
                { secondsToTimeAgo(getTimeSinceLastUpdated(props.timeLastUpdated)) }
            </span>
        ) }
    </div>
) : null);

RefreshView.propTypes = {
    timeLastUpdated: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)
};

RefreshView.defaultProps = {
    timeLastUpdated: null,
    styles
};

export default createRefreshControls(RefreshView);
